// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__1oZsj","assignButton":"CreateEditEquipmentSchedule_assignButton__17mLg"};